import { Component, Input } from '@angular/core';

import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  selector: 'entity-details-org',
  templateUrl: './entity-details-org.component.html'
})

export class EntityDetailsOrgComponent {
  @Input() entityIdDetails: EntityIdDetails;
  entityType = 'Org';

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/entities/details/entitydetailsorg/entity-details-org.component.ts